export const PriceSizes = ['md', 'lg'] as const
export type PriceSize = (typeof PriceSizes)[number]
export const PriceAligns = ['left', 'center'] as const
export type PriceAlign = (typeof PriceAligns)[number]
